/**
 * Пустой профиль дела. Используется при первом открытии карточки и в тестах.
 * Все массивы созданы, все признаки выставлены: интерфейс не должен разбираться
 * с `undefined`, а генератор — с отсутствующими ветками.
 */

import type { CaseProfile } from './types/profile.js';

export function createEmptyProfile(caseId: string): CaseProfile {
  return {
    schemaVersion: 1,
    revision: 0,
    caseId,
    stage: 'collecting',

    debtor: {
      last: '',
      first: '',
      middle: '',
      previousNames: [],
      gender: null,
      birthDate: null,
      birthPlace: '',
      inn: '',
      snils: '',
      idDocument: {
        kind: 'passport_rf',
        series: '',
        number: '',
        issuedBy: '',
        issuedAt: null,
        departmentCode: '',
      },
      registrationAddress: { full: '' },
      hasRegistration: true,
      stayAddress: { full: '' },
      phone: '',
      email: '',
    },

    declension: {
      fio: {
        nominative: '',
        genitive: '',
        dative: '',
        accusative: '',
        instrumental: '',
        prepositional: '',
      },
      manuallyEdited: {},
    },

    court: { id: null, name: '', address: '' },

    representative: {
      enabled: true,
      name: '',
      inn: '',
      address: '',
      phone: '',
      email: '',
      powerOfAttorney: '',
    },

    creditors: [],
    obligatoryPayments: [],

    property: {
      hasProperty: false,
      realty: [],
      vehicles: [],
      accounts: [],
      shares: [],
      securities: [],
      valuables: [],
    },

    deals: { hasDeals: false, items: [] },

    family: { statuses: [], spouses: [], children: [] },

    income: {
      employed: false,
      employerName: '',
      employerInn: '',
      monthlySalary: 0,
      salaryConfirmation: '',
      hasSocialPayments: false,
      socialPaymentsDescription: '',
      isEntrepreneur: false,
      hasOrganizations: false,
      organizations: [],
    },

    legal: {
      sro: { id: null, name: '' },
      creditBureau: { id: null, name: '' },
      creditReportKind: '',
      creditPurpose: '',
      creditorCertificatesClause: 'general',
      extraAppendixItems: [],
      appendixChecklist: {},
      applicationDate: null,
    },

    meta: { updatedAt: null, updatedByUserId: null },
  };
}

/** Идентификатор строки таблицы. Нужен спискам React и сопоставлению строк при правке. */
export function newRowId(): string {
  return 'r' + Math.random().toString(36).slice(2, 10);
}
